import PropTypes from "prop-types";
import React, { Component } from "react";
import styled, { css } from "styled-components";
import { colors } from "../theme";

import { isBrowser } from "@cortexglobal/cortex-utilities";

const StickyFooter = styled.footer`
    width: 100%;
    color: ${props => props.theme.footer.color};
    background: ${props => props.theme.footer.background};
    padding: ${props => props.theme.footer.padding}em 0 0;
    margin-top: ${props => props.theme.footer.margin}rem;
    ${props =>
        props.fixed &&
        css`
            bottom: 0;
            position: fixed;
        `};
`;

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fixed: false
        };
    }
    onElementHeightChange(elm, callback) {
        var lastHeight = elm.clientHeight,
            newHeight;
        (function run() {
            newHeight = elm.clientHeight;
            if (lastHeight != newHeight) callback();
            lastHeight = newHeight;

            if (elm.onElementHeightChangeTimer)
                clearTimeout(elm.onElementHeightChangeTimer);

            elm.onElementHeightChangeTimer = setTimeout(run, 200);
        })();
    }
    componentDidMount() {
        if (isBrowser()) {
            this.isFixed();
            // detect window change
            this.onElementHeightChange(document.body, () => {
                this.isFixed();
            });
        }
    }
    isFixed() {
        this.setState({
            fixed: Boolean(document.body.offsetHeight < window.innerHeight)
        });
    }
    render() {
        return (
            <StickyFooter
                fixed={this.state.fixed}
                background={this.props.background}
            >
                {this.props.children}
            </StickyFooter>
        );
    }
}
Footer.displayName = "Footer";

Footer.propTypes = {
    background: PropTypes.string
};

Footer.defaultProps = {
    background: Object.keys(colors)[0]
};

export default Footer;
